export default __webpack_public_path__ + "static/media/shunwood.196345d9.png";